import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { useNavigate } from "react-router-dom";
import { showDeletedAlert, showErrorAlert, showQuestionDeleteAlert, showUpdateAlert } from "../../components/molecules/ShowAlert";
import { eliminarDocente } from "../../services/docente.service";

export const DocenteCard = ({ docente, index, onDelete }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (!result.isConfirmed) return;

        try {
          await eliminarDocente(docente?.docente?.idDocente);
          showDeletedAlert({
            callback: () => onDelete?.(docente?.docente?.idDocente),
          });
        } catch (error) {
          console.error("Error al eliminar el docente:", error);
          showErrorAlert({});
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () =>
        navigate(`/docentes/actualizar/${docente?.docente?.idDocente}`),
    });
  };

  const {
    persona = {},
    usuario = {},
  } = docente || {};

  const {
    nombre = "",
    apellido = "",
    celular = "",
    ci = "_",
    correo = "_",
    sexo = "",
  } = persona;

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index}</td>
      <td className="border-r border-slate-200 border-t">{nombre}</td>
      <td className="border-r border-slate-200 border-t">{apellido}</td>
      <td className="border-r border-slate-200 border-t">{usuario?.username}</td>
      <td className="border-r border-slate-200 border-t">{celular}</td>
      <td className="border-r border-slate-200 border-t">{ci}</td>
      <td className="border-r border-slate-200 border-t">{correo}</td>
      <td className="border-r border-slate-200 border-t">{sexo}</td>
      <td className="border-slate-200 border-t">
        <div className="flex justify-start gap-4">
          <ActionButton icon={<EditIcon className="w-5 h-5" />} onClick={handleUpdate} color="green" />
          <ActionButton icon={<DeleteIcon className="w-5 h-5" />} onClick={handleDelete} color="red" />
        </div>
      </td>
    </tr>
  );
};

const ActionButton = ({ icon, onClick, color = "blue" }) => (
  <button
    onClick={onClick}
    className={`bg-${color}-500 p-1 rounded-md text-white hover:bg-${color}-600`}
  >
    {icon}
  </button>
);
